export default "__VITE_ASSET__cR5JOwej__"